import { render, staticRenderFns } from "./schoolUser.vue?vue&type=template&id=9f003ce2"
import script from "./schoolUser.vue?vue&type=script&lang=js"
export * from "./schoolUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports